import { compose } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import { NavTabsContainer } from 'altus-ui-components';
import SystemRoutesContainer from 'app/components/SystemRoutesContainer';
import { Grid } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import { BasePage } from 'altus-ui-components';
import AddIcon from '@material-ui/icons/Add';
import { Button, Tab } from '@material-ui/core';
import AddLogFileDrawer from 'features/wells/corrosion/components/AddLogFileDrawer';
import { useToggle } from 'altus-hooks';
import { useHeader } from 'app/hooks/useHeader';
import useWellbore from 'features/wells/hooks/useWellbore';
import { CORROSION_LOG_ACTIONS } from 'features/wells/corrosion/helpers/corrosionlogs.constants';
import { getSummarizedDataStateFromState } from 'app/app.selectors';

const CorrosionContainer = ({
  dataState,
  breadcrumb,
  routes,
  classes,
  wellboreId,
}) => {
  useHeader({ subTitle: breadcrumb });
  const location = useLocation();
  const hideAddButton = location && location.pathname.includes('comparelogs');
  const [showAddLogFile, toggleAddLogFile] = useToggle();
  const { wellbore } = useWellbore(wellboreId);

  return (
    <>
      <BasePage dataState={dataState}>
        <Grid container item className={classes.navContainer}>
          <Grid xs={8} item>
            <NavTabsContainer
              routes={routes}
              indicatorColor="primary"
              TabComponent={Tab}
              disableUnderline={true}
            />
          </Grid>
          <Grid xs={2} item className={classes.buttonContainer}>
            {!hideAddButton && (
              <Button
                title="Add Log FIle"
                color="primary"
                variant="contained"
                className={classes.addButton}
                onClick={toggleAddLogFile}
              >
                <AddIcon fontSize="small" />
                Add Log File
              </Button>
            )}
          </Grid>
        </Grid>
        {showAddLogFile && (
          <>
            <AddLogFileDrawer
              isOpen={showAddLogFile}
              toggleDrawer={toggleAddLogFile}
              externalWellboreId={wellbore.get('externalWellboreExternalId')}
            />
          </>
        )}
        <SystemRoutesContainer routes={routes} />
      </BasePage>
    </>
  );
};

const styles = (theme) => ({
  navContainer: {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default compose(
  connect((state) => ({
    dataState: getSummarizedDataStateFromState(
      state,
      CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOGS_LIST,
      CORROSION_LOG_ACTIONS.LOAD_COMPARE_FILES_DATA,
    ),
  })),
  withStyles(styles),
)(CorrosionContainer);
